export default function featuresReducer(state = {}, action) {
  switch (action.type) {
    case 'FEATURES_LOADED':
      return action.payload;
    default:
      return state;
  }
}
